import CentralMappingMappingEntrySerializer from 'lumen/serializers/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryRoomTypeSerializer extends CentralMappingMappingEntrySerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'data') {
      return super.modelNameFromPayloadKey(
        'central-mapping/mapping-entry-room-type',
      );
    }

    return key;
  }
}
